var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1593_5529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24301 7.33992L1.86301 8.26492L1.75001 8.28792C1.57895 8.33333 1.42301 8.42333 1.2981 8.54873C1.1732 8.67412 1.08381 8.83041 1.03907 9.00165C0.994331 9.17289 0.995837 9.35293 1.04344 9.5234C1.09104 9.69386 1.18303 9.84864 1.31001 9.97192L5.93201 14.4709L4.84201 20.8259L4.82901 20.9359C4.81854 21.1128 4.85528 21.2894 4.93546 21.4474C5.01564 21.6055 5.13639 21.7394 5.28535 21.8354C5.4343 21.9315 5.6061 21.9862 5.78316 21.994C5.96022 22.0019 6.13618 21.9625 6.29301 21.8799L11.999 18.8799L17.692 21.8799L17.792 21.9259C17.9571 21.9909 18.1365 22.0109 18.3118 21.9837C18.4871 21.9565 18.652 21.8832 18.7896 21.7712C18.9272 21.6592 19.0326 21.5127 19.0948 21.3466C19.1571 21.1804 19.1741 21.0008 19.144 20.8259L18.053 14.4709L22.677 9.97092L22.755 9.88592C22.8664 9.74869 22.9395 9.58438 22.9667 9.40972C22.994 9.23506 22.9744 9.0563 22.9101 8.89165C22.8458 8.72701 22.7389 8.58236 22.6005 8.47244C22.4621 8.36252 22.297 8.29126 22.122 8.26592L15.742 7.33992L12.89 1.55992C12.8075 1.39246 12.6797 1.25144 12.5212 1.15283C12.3627 1.05422 12.1797 1.00195 11.993 1.00195C11.8063 1.00195 11.6234 1.05422 11.4648 1.15283C11.3063 1.25144 11.1785 1.39246 11.096 1.55992L8.24301 7.33992Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1593_5529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/Star Fill.f1a2bedfb20a454a6dcd8a7016b0c485.svg";
export { ForwardRef as ReactComponent };